import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from "formik";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import * as Yup from 'yup'
import { useDispatch } from "react-redux";
import { failureAlert, successAlertRefresh } from "../../CommonUtils/SweetAlerts";
import allowNumbersOnly, { handlePaste } from "../../CommonUtils/CommonValidations";
import Swal from "sweetalert2";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";

export default function AffiliationLabEquipmentMap() {
    const dispatch = useDispatch()
    const [flag, setFlag] = useState(false)
    const [courseCode, setCourseCode] = useState('')
    const validationSchema = Yup.object().shape({
        labs: Yup.array().of(
            Yup.object().shape({
                equiQuantity: Yup.string().required("required"),
                nameEquipment: Yup.string().required("required"),
            })
        ),
    });
    const labEquipFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            labs: [{
                labDetails: courseCode || '',
                nameEquipment: "",
                equiQuantity: ""
            }]
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let EquipQuantity = parseInt(values?.equiQuantity, 10);

                    values.equiQuantity = isNaN(EquipQuantity) ? null : EquipQuantity;
                    let url = config.url.API_URL + `savelabEquipmentdetails`
                    CommonAxiosPost(url, values?.labs, dispatch).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlertRefresh(res?.data?.sdesc)
                        }
                        else {
                            failureAlert(res?.data?.sdesc)

                        }
                    })
                }
            })
        }
    })
    const [LabEqipData, setLabEqipData] = useState([]);
    function GetLabData() {
        let url = config.url.API_URL + `getequipmentData`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setLabEqipData(res?.data?.equipmentDetails)

            } else {
                setLabEqipData([])

            }
        })
    }

    const [getLabData, setLabData] = useState('');
    function SubmittedGetlabData(labname) {
        let url = config.url.API_URL + `getlabequipmentData/` + labname;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setLabData(res?.data?.labequipmentData)
                res?.data?.labequipmentData?.forEach((data, i) => {
                    labEquipFormik.setFieldValue(`labs[${i}].nameEquipment`, data?.name_equipment + '');
                    labEquipFormik.setFieldValue(`labs[${i}].equiQuantity`, data?.equi_quantity + '');

                });
            } else {
                setLabData([])

            }
        })
    }

    useEffect(() => {
        GetLabData();
        SubmittedGetlabData();
    }, [])

    const [rowcount, setrowcount] = useState([])
    const Columns = [
        {
            Header: "Sl.no",
            accessor: (row, index) => index + 1,
            Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value}</div>,

        },
        {
            Header: "Name of the Laboratory",
            accessor: "lab_details",
            Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row?.values?.lab_details ? row?.values?.lab_details : <b>-</b>}</div>
        },
        {
            Header: "Total Equipments",
            accessor: "tot",
            Cell: ({ row }) => (
                <div>
                    <button type='button' onClick={(e) => { setFlag(true); setCourseCode(row?.original?.lab_details); setrowcount(row?.values?.tot); SubmittedGetlabData(row?.original?.lab_details) }}
                        className='text-center' style={{ textDecoration: "underline", color: "blue" }}>
                        {row?.values?.tot === 0 ? 'Please Add Equipments' : row?.values?.tot}
                    </button>
                </div>
            )
        }

    ]


    return (
        <>

            <Container fluid className="px-1" >
                {!flag ? (<>

                    <CommonFormHeading heading={"Lab Equipment Mapping"} />

                    {/* <bie.Row>
                        <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} className="">
                            <div className="inner-herbpage-service-title1">
                                <h1>Lab Equipment Mapping</h1>
                            </div>
                        </bie.Col>
                        <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>
                            <button className="breadcrumb-item"><a href="/dashboard" className='affl-dash'><FaHome size={30} /></a></button>
                        </bie.Col>
                    </bie.Row> */}
                    <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" >
                        {/* {LabEqipData && LabEqipData?.length > 0 ? (<>
                            <strong style={{ color: "red" }}> Note:Don't repeat the same Lab name in same Building block</strong>
                        </>) : null} */}

                        {LabEqipData && LabEqipData?.length > 0 ? (
                            <div className='table-responsive'>
                                <CommonReactTable data={LabEqipData} columns={Columns} paginationCount="All" excelFlag={false} printFlag={false} filename="Affiliation LAb Equipment Map" />
                            </div>
                        ) : (
                            <b className='text-error text-center'>No data Found</b>
                        )}
                        <br />

                    </Container>
                </>
                ) : (
                    <>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10}>
                                <div className="inner-herbpage-service-title1">
                                    <h1>Lab Equipment Mapping</h1>

                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                <div className='d-flex flex-row justify-content-end'>
                                    <button type="button" className='btn btn-sm btn-secondary'
                                        onClick={() => { setFlag(false); }}>Back</button>
                                </div>
                            </Col>

                        </Row>
                        <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" style={{ backgroundColor: '#FAF7F0' }}>

                            <FormikProvider value={labEquipFormik}>
                                <Form onChange={labEquipFormik.handleChange} onSubmit={labEquipFormik.handleSubmit}>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive table-stripped">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Name of the Equipment</th>
                                                    <th>Equipment Quantity</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <FieldArray name="labs">
                                                    {({ push, remove }) => {

                                                        return (
                                                            <>
                                                                {labEquipFormik.values.labs.map((detail, index) => (
                                                                    <tr key={index}>
                                                                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                                                                        <td>
                                                                            <Field type="text" className="form-control" name={`labs[${index}].nameEquipment`} style={{ width: "100%" }} maxLength={30}></Field>
                                                                            <ErrorMessage name={`labs[${index}].nameEquipment`} component="div" className="text-error" />
                                                                        </td>
                                                                        <td>
                                                                            <Field type="text" className="form-control" name={`labs[${index}].equiQuantity`} style={{ width: "100%" }} maxLength="3"
                                                                                onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { allowNumbersOnly(e); }}></Field>
                                                                            <ErrorMessage name={`labs[${index}].equiQuantity`} component="div" className="text-error" />
                                                                        </td>
                                                                        <td align="center">
                                                                            {index === 0 && (
                                                                                <button
                                                                                    type="button"
                                                                                    className="button-title btn btn-sm btn-success"
                                                                                    onClick={() => {
                                                                                        push({
                                                                                            labDetails: courseCode || '',
                                                                                            nameEquipment: "",
                                                                                            equiQuantity: ""

                                                                                        });
                                                                                    }}>
                                                                                    <VscDiffAdded />
                                                                                </button>
                                                                            )}
                                                                            {index >= 1 && (
                                                                                <button type="button" className="button-title btn btn-sm btn-danger"
                                                                                    onClick={() => {
                                                                                        remove(index);
                                                                                    }}
                                                                                >
                                                                                    <BiTrash />
                                                                                </button>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </>
                                                        );
                                                    }}
                                                </FieldArray>
                                            </tbody>
                                        </table>
                                    </div>
                                    <button type='submit' className="btn btn-success btn-sm float-end" >Submit</button>
                                </Form>
                            </FormikProvider>
                        </Container>
                    </>
                )}
            </Container>

        </>
    )
}
